export const ApiEndpoint = {
    search: () => document.getElementById("data--api-endpoint").dataset.apiEndpoint,
    searchMode: () => document.getElementById("data--api-endpoint").dataset.apiEndpointMode,
    makerMode: () => document.getElementById("data--api-endpoint").dataset.apiEndpointMode,
};
